<template>
  <v-row dense>
    <v-col cols="12">
      <v-card outlined flat>
        <v-card-text>
          <v-col cols="12">
            <div class="card-content text-center">Esta aula possui uma lista de exercícios de tempo limitado</div>
          </v-col>

          <v-col cols="12" v-if="value.response_interval_init">
            <div class="card-content text-xs-left">
              O período para iniciar é de {{ formatDate(value.response_interval_init) }}
              até {{ formatDate(value.response_interval_end) }}.<br/>
              Não será possível responder esta lista fora do período estipulado.
            </div>
          </v-col>

          <v-col cols="12" v-if="value.deadline">
            <div class="card-content text-xs-left">
              Ao iniciar a lista você terá {{ formatTime(value.deadline) }} para responder todas as questões.<br/>
              Após este tempo não será mais possível responder esta lista e as questões
              não respondidas receberão nota 0 automaticamente.
            </div>
          </v-col>
        </v-card-text>

        <v-card-actions >
          <v-spacer/>
          <v-btn text color="primary" @click="loadData">Responder Agora</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <v-row dense v-if="showNavigationButtons" class="mt-2">
      <v-tooltip top v-if="isPreviousLesson">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on" large color="info" @click="toPrevious()">
            <v-icon left dark>mdi-skip-previous</v-icon>
          </v-btn>
        </template>
        <span>Aula anterior: {{ previousLesson.title }}</span>
      </v-tooltip>
      <v-spacer/>
      <v-tooltip top v-if="isNextLesson">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on" large color="info" @click="toNext()">
            <v-icon right dark>mdi-skip-next</v-icon>
          </v-btn>
        </template>
        <span>Próxima aula: {{ nextLesson.title }}</span>
      </v-tooltip>
    </v-row>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default () {
        return {
          deadline: null,
          response_interval_init: null,
          response_interval_end: null
        }
      }
    },
    previousLesson: {
      type: Object,
      default () {
        return {}
      },
      required: false
    },
    nextLesson: {
      type: Object,
      default () {
        return {}
      },
      required: false
    }
  },
  computed: {
    /**
     * Verifica se os botões de navegação devem ser mostrados
     */
    showNavigationButtons () {
      return (this.isPreviousLesson || this.isNextLesson) && (this.exercisePosition !== 0)
    },
    /**
     * Verifica se há uma aula anterior a lista de exercícios
     */
    isPreviousLesson () {
      return this.previousLesson ? typeof this.previousLesson.id !== 'undefined' : false
    },
    /**
     * Verifica se há uma aula posterior a lista de exercícios
     */
    isNextLesson () {
      return this.nextLesson ? typeof this.nextLesson.id !== 'undefined' : false
    }
  },
  methods: {
    /**
     * Emite um evento indicando que o aluno deseja começar a
     * responder a lista de exercícios
     */
    loadData () {
      this.$emit('load')
    },
    /**
     * Formata uma data de acordo com a localização
     */
    formatDate (value) {
      return (new Date(value)).toLocaleString('pt-BR')
    },
    /**
     * Formata um dado valor em minutos, em seu correspondente
     * em horas e minutos
     */
    formatTime (value) {
      const H = Math.trunc(value / 60)
      const m = value % 60
      return H + 'H e ' + m + 'min'
    },
    /**
     * Passa para a próxima aula
     */
    toNext () {
      this.$emit('nextLesson')
    },
    /**
     * Passa para a aula anterior
     */
    toPrevious () {
      this.$emit('previousLesson')
    }
  }
}
</script>

<style>
  .card-content {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    flex-grow: 1;
  }
</style>
